import apiEndpoints from '../../const/apiEndpoints'
import api from '../../services'
import { createAsyncThunk } from '@reduxjs/toolkit'
import history from '../../const/history'
import ROUTES from '../../const/routes'
import strings from '../../locale/en'
import { getClearMaterial } from '../learnSession/api'

export const saveMaterial = createAsyncThunk(
  'course/saveMaterial',
  async (payload: any, { dispatch }): Promise<string> => {
    const response = await api.post(apiEndpoints.saveMaterial, payload)
    if (response) {
      history.push(ROUTES.ADMIN_MATERIAL)
      dispatch(getClearMaterial())
    }
    return response ? '' : strings?.error.addMaterialFailed
  }
)
